module.exports = __webpack_public_path__ + "img/aprueba-elige.5afaee02.png";